// import { REFER_EQUIPMENT } from './referType';
import ReferList from '../../components/ReferList';

export default class ReferViewMeta {
    constructor(equipment) {
        this.equipment = equipment;
    }

    // 根据设备判断返回的组件
    getViewComponent () {
        return new ReferList()
    }
}